import { render, staticRenderFns } from "./svgCurves.vue?vue&type=template&id=6b3a1843&scoped=true&"
import script from "./svgCurves.vue?vue&type=script&lang=js&"
export * from "./svgCurves.vue?vue&type=script&lang=js&"
import style0 from "./svgCurves.vue?vue&type=style&index=0&id=6b3a1843&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3a1843",
  null
  
)

export default component.exports